import api from './api';
import { Partner, PartnerFormData, ApiResponse, PaginatedResponse } from '../types';

export const partnerService = {
  async getAll(page = 1, search = ''): Promise<PaginatedResponse<Partner>> {
    const response = await api.get<PaginatedResponse<Partner>>('/partners', {
      params: { page, search }
    });
    return response.data;
  },

  async getById(id: number): Promise<Partner> {
    const response = await api.get<Partner>(`/partners/${id}`);
    return response.data;
  },

  async getActive(): Promise<Partner[]> {
    const response = await api.get<Partner[]>('/partners/active');
    return response.data;
  },

  async create(data: PartnerFormData): Promise<ApiResponse<Partner>> {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      // Não enviar o campo logo se for null ou não for um File
      if (key === 'logo' && !(value instanceof File)) {
        return;
      }

      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          // Enviar boolean como 1 ou 0 para o Laravel
          formData.append(key, value ? '1' : '0');
        } else if (Array.isArray(value)) {
          // Ex: category_ids -> vira category_ids[] repetido, não uma string "1,2"
          value.forEach((item) => formData.append(`${key}[]`, String(item)));
        } else {
          formData.append(key, String(value));
        }
      }
    });

    const response = await api.post<ApiResponse<Partner>>('/partners', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async update(id: number, data: PartnerFormData): Promise<ApiResponse<Partner>> {
    // Sempre usar FormData para manter consistência com o backend
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      // Não enviar o campo logo se for null ou não for um File
      if (key === 'logo' && !(value instanceof File)) {
        return;
      }

      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          // Enviar boolean como 1 ou 0 para o Laravel
          formData.append(key, value ? '1' : '0');
        } else if (Array.isArray(value)) {
          // Ex: category_ids -> vira category_ids[] repetido, não uma string "1,2"
          value.forEach((item) => formData.append(`${key}[]`, String(item)));
        } else {
          formData.append(key, String(value));
        }
      }
    });

    // Usar POST diretamente (sem _method spoofing) já que a rota aceita POST
    const response = await api.post<ApiResponse<Partner>>(`/partners/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`/partners/${id}`);
    return response.data;
  },

  async toggleActive(id: number): Promise<ApiResponse<Partner>> {
    const response = await api.patch<ApiResponse<Partner>>(`/partners/${id}/toggle-active`);
    return response.data;
  }
};
